import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { BaseApiTemplateService, Core2Config } from '../../shared';
import { CurrentCompanyStockBalanceContainerModel } from '../../../../../../models/aggregates/company';




@Injectable({providedIn: 'root'})
export class CurrentCompanyStockBalanceService extends BaseApiTemplateService<CurrentCompanyStockBalanceContainerModel>  {

    readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "current-company-stock-balances/backoffice-ep"
  
    constructor(http: HttpClient) {
      super();
      this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "current-company-stock-balances/backoffice-ep"
      this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.INV_PREFIX + "current-company-stock-balances/backoffice-ep"
      this.httpClient = http;
    } 
  }
  